import axios from 'axios';

/** commercetools' ConcurrentModification, as the bridge words or names it. */
const VERSION_CONFLICT_PATTERN = /different version|ConcurrentModification/i;

/**
 * A cart write refused because the cart moved on since it was read: another
 * tab's write landed first (CPS-7696). The bridge answers 412, 409, or 400
 * naming the version; a reread gets the version the write needs.
 */
export const isCartVersionConflict = (error: unknown): boolean => {
  if (!axios.isAxiosError(error) || !error.response) return false;
  const { status, data } = error.response;
  if (status === 412 || status === 409) return true;
  return status === 400 && VERSION_CONFLICT_PATTERN.test(JSON.stringify(data));
};
